const locale = require('./detailedHistory.i18n.json');

/*@ngInject*/
const DetailedHistoryGridColumnModel = function ($http, $q, $rootScope, xmlUtil, preferenceModel, gridColumnConstant) {

    var viewActiveOnlyCheckBoxChecked = true,
        columnPreference,
        selectedSubmissionFilterName,
        selectedTaskFilterName,
        openFilterUri;

    var detailedHistoryParams = {
        key: 'status',
        startIndex: 0,
        pageSize: 25,
        sortType: 'asc',
        searchString: '',
        filterUri: ''
    };

    this.setColumnPreference = function (preference) {
        columnPreference = preference;
    };

    this.getDetailedHistoryParams = function () {
        return submissionParams;
    };

    this.setDetailedHistoryParams = function (_submissionParams) {
        submissionParams = _submissionParams;
    };

    this.getGridColumnXML = function (col) {
        var count = 0;
        var xml = '<columns>';
        var columns = this.getDropdownColumns();
        angular.forEach(columns, function (item) {
            if (item.name === col.name) {
                columns[count].visible = col.visible;
                xml += '<column visible="' + col.visible + '" width="' + item.width + '">' + item.name + '</column>';
            } else {
                xml += '<column visible="' + item.visible + '" width="' + item.width + '">' + item.name + '</column>';
            }
            count++;
        });
        xml += '</columns>';
        return xml;
    };

    this.reset = function () {
        viewActiveOnlyCheckBoxChecked = true;
        selectedSubmissionFilterName = _.get(locale, 'myAgencySubmissions');
        selectedTaskFilterName = _.get(locale, 'myTasks');
        submissionParams = {
            key: 'status',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc',
            searchString: '',
            filterUri: ''
        };
        taskParams = {
            key: 'insuredName',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc',
            searchString: '',
            criteriaName: ''
        };
    };

    this.getDropdownColumns = function () {
        var columns = xmlUtil.parseString(preferenceModel.get(columnPreference));
        if (!columns) {
            return;
        }

        var dropDownArray = [];
        _.each(columns.column, function (item) {
            var visibleProp = item._visible === 'true';
            var columnName = item.__text;
            dropDownArray.push({
                displayName: _.get(locale, 'grid.header.'+columnName),
                name: columnName,
                width: item._width,
                visible: visibleProp,
                disabled: columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED
            });
        });

        return dropDownArray;
    };

    this.getGridColumns = function () {
        var colViewModel = {};
        var columns = xmlUtil.parseString(preferenceModel.get(columnPreference));
        if (!columns) {
            return;
        }

        _.each(columns.column, function (item) {
            var visibleProp = item._visible === 'true';
            colViewModel[item.__text] = visibleProp;
        });

        return colViewModel;
    };
};
angular.module('gw-um-submission').service('detailedHistoryGridColumnModel', DetailedHistoryGridColumnModel);
